var slides = document.getElementsByClassName("swiper-slide-cards");
var container = document.getElementsByClassName("cards-container");
var buttons = document.getElementsByClassName("button-container");
var wrapper = document.getElementsByClassName("swiper-wrapper-cards");
var scrollbar = document.getElementsByClassName("container-scrollbar");


const sizes = {}
sizes.width = window.innerWidth
sizes.height = window.innerHeight

let numberSlideVisible = Math.floor((sizes.width - 200 + (5/100 * sizes.width)) / (390 + (5/100 * sizes.width)));
//386 est la width maximun d'une cards et 30 son margin right. 200 est le padding de chaque côté (100 *2)

window.addEventListener('resize', () =>
{
	sizes.width = window.innerWidth
	sizes.height = window.innerHeight

	numberSlideVisible = Math.floor((sizes.width - 200 + (5/100 * sizes.width)) / (390 + (5/100 * sizes.width)));
	handleCarrousel();
})

function handleCarrousel() {

	for(let j=0; j < container.length; j++){

		// The number of slides by carrousel
		let slideCount = 0;
		for(let i = 0; i < wrapper[j].childNodes.length; i++){
			if(wrapper[j].childNodes[i].nodeName == "LI"){
				slideCount++;
			}
		}
	
		// Hide the carrousel if the conditions are not true
		if((slideCount <= numberSlideVisible) || (wrapper[j].className.includes('small'))){
			container[j].classList.remove("cards-container-carrousel")
			
			for(let k = j*2; k < j*2 + 2; k++){
				if(buttons[k]) {
					buttons[k].classList.add("btn-hidden");
				}
			}
			if(scrollbar[j])
			{
				scrollbar[j].classList.add('container-scrollbar-hidden')
			}
		}
		else {
			if(slideCount === 1) {
				container[j].classList.remove("cards-container-carrousel")
				scrollbar[j].classList.add('container-scrollbar-hidden')
			}
			else {
				container[j].classList.remove("cards-container-nocarrousel")
			}
		}
	
		// To define the height of the slide buttons
		let slidesHeight = container[j].offsetHeight;
	
		if(buttons.length > 0) {
			for(let k =j*2; k <j*2+2; k++){
				buttons[k].style.height = slidesHeight + 1 + "px";
			}
		}
	}
}

handleCarrousel();







